// Segmented "محادثات / مكالمات" toggle used at the top of the content area.
// When voice calls are disabled via feature flag, the "مكالمات" tab is
// hidden entirely and this component renders nothing (parent shows only
// the chats list, no toggle needed).
import { VOICE_CALLS_ENABLED } from "../../lib/featureFlags";

export default function TabsBar({ tab, setTab }) {
  if (!VOICE_CALLS_ENABLED) return null;
  const btnCls = (active) =>
    `flex-1 py-1.5 rounded-full text-[12.5px] font-bold transition active:scale-95 ${
      active
        ? "bg-[#0A192F] text-white shadow-[0_3px_10px_rgba(10,25,47,0.25)]"
        : "text-[#5A6470]"
    }`;
  return (
    <div className="pb-3 pt-1">
      <div
        className="mx-auto max-w-[280px] bg-white/70 backdrop-blur-md border border-white/70 rounded-full p-1 flex shadow-[0_2px_10px_rgba(10,25,47,0.06)]"
        role="tablist"
        data-testid="messages-tabs"
      >
        <button
          type="button" role="tab" aria-selected={tab === "chats"}
          onClick={() => setTab("chats")}
          className={btnCls(tab === "chats")}
          data-testid="messages-tab-chats"
        >
          محادثات
        </button>
        <button
          type="button" role="tab" aria-selected={tab === "calls"}
          onClick={() => setTab("calls")}
          className={btnCls(tab === "calls")}
          data-testid="messages-tab-calls"
        >
          مكالمات
        </button>
      </div>
    </div>
  );
}
